/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IFinishOauthIntegrationAuthMutationVariables = Types.Exact<{
  provider: Types.OauthIntegrationProviderEnum;
  clientPayload: Types.IIntegrationAuthClientPayloadInput;
  stateToken: Types.Scalars['String']['input'];
  options?: Types.InputMaybe<Types.IIntegrationAuthOptionsInput>;
}>;

export type IFinishOauthIntegrationAuthMutation = {
  __typename?: 'Mutation';
  finishOauthIntegrationAuth?: {
    __typename?: 'FinishAuthPayload';
    success: boolean;
    errors?: Array<string> | null;
    oauthIntegration?: {
      __typename?: 'OauthIntegration';
      id: string;
      accountName?: string | null;
      provider: string;
    } | null;
  } | null;
};

export const FinishOauthIntegrationAuthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'finishOauthIntegrationAuth' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'OauthIntegrationProviderEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientPayload' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntegrationAuthClientPayloadInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stateToken' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'options' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntegrationAuthOptionsInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finishOauthIntegrationAuth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'provider' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientPayload' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientPayload' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'stateToken' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'stateToken' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'options' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'options' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'oauthIntegration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IFinishOauthIntegrationAuthMutation, IFinishOauthIntegrationAuthMutationVariables>;
